import { Section } from '@factorialco/deprecated-design-system'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import TimeReimbursements from 'modules/compensations/pages/settings/TimeReimbursements'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const TimeReimbursementsPage = () => {
  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <Section.FullWidth
        illustration="Replace"
        title={i18n.t('compensations.settings.time_reimbursements.title')}
        description={i18n.t('compensations.settings.time_reimbursements.description')}
        link={{
          href: helpCenterUrl('payroll_additional_compensations'),
          label: i18n.t('compensations.settings.time_reimbursements.help_text'),
        }}
      >
        <TimeReimbursements />
      </Section.FullWidth>
    </ResponsivePage.Body>
  )
}

export default TimeReimbursementsPage
